import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormField, FormGrid, SelectionList, Text, } from '@dixa/lib-shared-habla';
import { Controller, } from 'react-hook-form';
import { FieldTemplate } from 'components/fieldTemplate';
import { HookFormSelectionList } from 'components/hookForm';
import { useBreakpointValue } from 'utils/mediaQuery';
import { editorMaxLines } from '../../../../../../configuration';
const contentTypes = [
    { id: 'application/json', label: 'application/json' },
    {
        id: 'application/x-www-form-urlencoded',
        label: 'application/x-www-form-urlencoded',
    },
    { id: 'text/plain', label: 'text/plain' },
    { id: 'text/html', label: 'text/html' },
    { id: 'text/xml', label: 'text/xml' },
    { id: 'text/csv', label: 'text/csv' },
];
export const RequestBody = ({ control, className, disabled, }) => {
    const isMediumScreen = useBreakpointValue({ base: true, lg: false });
    return (_jsxs(FormGrid, Object.assign({ className: className }, { children: [_jsx(FormField, Object.assign({ span: isMediumScreen ? 6 : 2 }, { children: _jsx(HookFormSelectionList, Object.assign({ disabled: disabled, control: control, label: "Content type", name: 'request.content_type', componentProps: {
                        clearable: true,
                        placeholder: 'Select content type',
                        getItemTitleByValue: (type) => (_jsx(Text.Paragraph, { children: type })),
                    } }, { children: contentTypes.map((type) => (_jsx(SelectionList.Item, Object.assign({ value: type.id }, { children: type.label }), type.id))) })) })), _jsx(FormField, { children: _jsx(Controller, { name: 'request.body', control: control, render: ({ field }) => (_jsx(FieldTemplate, { disabled: disabled, label: "Body", input: field, placeholder: "Insert body", height: "100%", mode: "json", editorOptions: {
                            maxLines: editorMaxLines,
                        } })) }) })] })));
};
